/**
 * The 10% Administration Fee is hidden from everything users see until leadership approves showing it:
 * the payment terms, the fee panel, the document's name and every "Fee Schedule" link or label.
 * The fee is still calculated and stored by the backend. Set to true to restore the original copy.
 */
export const SHOW_ADMINISTRATION_FEE = false;

/** Heading of the Creator Payments document. */
export const PAYMENT_TERMS_TITLE = SHOW_ADMINISTRATION_FEE
	? "Creator Payments — Terms of Service & Administration Fee Schedule"
	: "Creator Payments — Terms of Service";

/** The document's name as it is cited in running text (e.g. the Platform Terms). */
export const PAYMENT_TERMS_NAME = SHOW_ADMINISTRATION_FEE
	? "Creator Payments Terms of Service and Administration Fee Schedule"
	: "Creator Payments Terms of Service";

/** Short label for links and tabs that open the document. */
export const PAYMENT_TERMS_LABEL = SHOW_ADMINISTRATION_FEE ? "Fee Schedule" : "Payment Terms";

/**
 * The public Payment Terms page (/fee-schedule) and its landing page footer link are off (Ticket 393).
 * While false the route is not registered, so the URL falls through to the not-found page.
 * Set to true to bring both back.
 */
export const SHOW_LANDING_PAYMENT_TERMS_LINK = false;
